/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const FlashNotification = function (options) {
  this.options = options
  return this
}

FlashNotification.prototype = {
  error(html, options) {
    if (options == null) {
      options = {}
    }
    options.growl = _.extend(options.growl || {}, { delay: 6000 })
    return this.addNotification(html, "error", _.extend(options))
  },

  success(html, options) {
    if (options == null) {
      options = {}
    }
    return this.addNotification(html, "success", options)
  },

  info(html, options) {
    if (options == null) {
      options = {}
    }
    return this.addNotification(html, "info", options)
  },

  warning(html, options) {
    if (options == null) {
      options = {}
    }
    return this.addNotification(html, "warning", options)
  },

  addNotification(html, type, options) {
    if (type == null) {
      type = "success"
    }
    if (options == null) {
      options = {}
    }
    if (type === "notice") {
      type = "info"
    }

    const pnotifyOptions = {
      title:
        options.type != null ? options.type : I18n.t(`growls.title.${type}`),
      text: html,
      type,
      sticker: false,
      animate_speed: "fast"
    }

    if (options.delay != null) {
      pnotifyOptions.delay = options.delay
    }

    return $.pnotify(_.extend(pnotifyOptions, options.growl || {}))
  }
}

export default FlashNotification
